<app-header></app-header>
<div class="title"></div>
<div class="container margin-top-70">
  <div class="row">
    <div class="col-md-6 mt-6">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td class="v-align-m">
              Product ID
            </td>
            <td colspan="2">
              <input
                type="text"
                class="form-control"
                [(ngModel)]="selectedproductId"
                placeholder=""
              />
            </td>
          </tr>
          <tr>
            <td class="v-align-m">
              Published Date
            </td>
            <td style="vertical-align: middle;">
              <app-drop-down-single-select
                [DropDownOptions]="selectTypeDropDownOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'publishedDate'"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-date-select
                class="form-control"
                [additionalClasses]="'float-left'"
                [product]=""
                type="publishedDate"
                (dateSelected)="updateSelectedDate($event)"
              ></app-date-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-md-6 mt-6">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td class="v-align-m">
              Contract Status
            </td>
            <td>
              <app-drop-down-single-select
                [DropDownOptions]="selectStatusTypeDropDownOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'contractStatus'"
                [selectedOption]="DefaultselectedOptionType"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-drop-down
                type="contractStatus"
                [settings]="dropdownSettingsBookType"
                [list]="dropdownListContractStatus"
                (dropDownChanged)="updateSelectedDropDown($event)"
                [selectedItems]="selectContractStatusTypeDropDownOptions"
              ></app-drop-down>
            </td>
          </tr>
          <tr>
            <td class="v-align-m">
              Book Type
            </td>
            <td colspan="2">
              <app-drop-down
                type="bookType"
                [settings]="dropdownSettingsBookType"
                [list]="dropdownListBookType"
                (dropDownChanged)="updateSelectedDropDown($event)"
              ></app-drop-down>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="container">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-pkt btn-primary me-1"
      (click)="searchProduct()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-pkt btn-primary"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
  </div>
</div>

<div class="container">
  <div class="container table-responsive" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col" style="width: 10%;">Contract Id</th>
          <th scope="col" style="width: 10%;">Contract Name</th>
          <th scope="col" style="width: 10%;">Contracted Date</th>
          <th scope="col" style="width: 10%;">Published Date</th>
          <th scope="col" style="width: 10%;">Author Name</th>
          <th scope="col" style="width: 10%;">Currency</th>
          <th scope="col" style="width: 10%;">Advance Total</th>
          <th scope="col" style="width: 10%;">Netsuite Id</th>
          <th scope="col" style="width: 10%;">Product Id</th>
          <th scope="col" style="width: 10%;">Product Status</th>
          <th scope="col" style="width: 10%;">ISBN-10P</th>
          <th scope="col" style="width: 10%;">Print Band 1(%)</th>
          <th scope="col" style="width: 10%;">Ebook Band 1(%)</th>
          <th scope="col" style="width: 10%;">Video Band 1(%)</th>
          <th scope="col" style="width: 10%;">Course Band 1(%)</th>
          <th scope="col" style="width: 10%;">Translation Band 1(%)</th>
          <th scope="col" style="width: 10%;">
            PacktLib Subscription Band 1(%)
          </th>
          <th scope="col" style="width: 10%;">
            3rd Party Subscription Band 1(%)
          </th>
          <th scope="col" style="width: 10%;">AudioBook Band 1(%)</th>
          <th scope="col" style="width: 10%;">Quizzes Band 1(%)</th>
          <th scope="col" style="width: 10%;">Status</th>
          <th scope="col" style="width: 10%;">Contract Type</th>
          <th scope="col" style="width: 10%;">Book Type</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{product.id}}</td>
          <td>{{product?.name}}</td>
          <td>
            {{ (product?.products?.date) ?
            product?.products?.date?.contracted_date : '' }}
          </td>
          <td>
            {{ (product?.products) ? product?.products?.publishing_date : '' }}
          </td>
          <td>{{ (product.author) ? product.author?.name : '' }}</td>
          <td>
            {{ (product?.contracted_currency_smb &&
            product.contracted_currency_smb !== null &&
            product.contracted_currency_smb !== undefined &&
            product.contracted_currency_smb !== '') ?
            getCurrencySymb(product.contracted_currency_smb) : '' }}
          </td>
          <td>{{ product?.advances | number : '1.2-2' }}</td>
          <td>
            {{ (product?.author && product.author?.contact.length > 0) ?
            product?.author?.contact[0]?.netsuite_internal_id : '' }}
          </td>
          <td>
            {{ (product?.products) ? product?.products?.part_number : '' }}
          </td>
          <td>
            {{ (product?.products?.status && product.products?.status.length >
            0) ? product?.products?.status[0].format : '' }}
          </td>
          <td>
            {{ (product?.products && product.products.isbn) ?
            product?.products?.isbn?.isbn_10 : '' }}
          </td>
          <td>
            {{ (product?.royalty_rate && product.royalty_rate.length > 0) ?
            product.royalty_rate[0]?.print_band_1 : '' }}
          </td>
          <td>
            {{ (product?.royalty_rate && product.royalty_rate.length > 0) ?
            product.royalty_rate[0]?.ebook_band_1 : '' }}
          </td>
          <td>
            {{ (product?.royalty_rate && product.royalty_rate.length > 0) ?
            product.royalty_rate[0]?.video_band_1 : '' }}
          </td>
          <td>
            {{ (product?.royalty_rate && product.royalty_rate.length > 0) ?
            product.royalty_rate[0]?.course_band_1 : '' }}
          </td>
          <td>
            {{ (product?.royalty_rate && product.royalty_rate.length > 0) ?
            product.royalty_rate[0]?.translation_band_1 : '' }}
          </td>
          <td>
            {{ (product?.royalty_rate && product.royalty_rate.length > 0) ?
            product.royalty_rate[0]?.packtlib_band_1 : '' }}
          </td>
          <td>
            {{ (product?.royalty_rate && product.royalty_rate.length > 0) ?
            product.royalty_rate[0]?.third_party_band_1 : '' }}
          </td>
          <td>
            {{ (product?.royalty_rate && product.royalty_rate.length > 0) ?
            product.royalty_rate[0]?.audiobook_band_1 : '' }}
          </td>
          <td>
            {{ (product?.royalty_rate && product.royalty_rate.length > 0) ?
            product.royalty_rate[0]?.quizzes_band_1 : '' }}
          </td>
          <td>{{ product.status }}</td>
          <td>{{ product.royalty_type }}</td>
          <td>{{ product?.products?.book_type }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>

<app-footer></app-footer>
